import { createSelector } from '@ngrx/store';
import { getOrderTypes } from '../getOrderTypes';

export const getOrderTypeDetailsDefinitionModel = (orderTypeId: number) =>
    createSelector(getOrderTypes, (orderType) => orderType?.data?.find((obj) => obj.Id === orderTypeId)?.Details);
